module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNi43NiA2Ny44OCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6IzViNWI1Yjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93LXJpZ2h0LXN3aXBlcjwvdGl0bGU+PHBvbHlnb24gY2xhc3M9ImEiIHBvaW50cz0iMzYuNzYgMzMuOTQgMi44MiAwIDAgMi44MyAzMS4xMSAzMy45NCAwIDY1LjA1IDIuODIgNjcuODggMzYuNzYgMzMuOTQgMzYuNzYgMzMuOTQgMzYuNzYgMzMuOTQiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-right-swiper.svg
// module id = IUwR
// module chunks = 0